/**
 * PageLoadingIndicator - A minimal, subtle loading indicator for route transitions
 *
 * This component provides a nearly invisible loading state that prevents layout flicker
 * while new pages load. It's intentionally minimal to create a seamless experience.
 *
 * Design choices:
 * - Takes full height to prevent layout shift
 * - No visual loading spinner (keeps previous content visible as long as possible)
 * - Can be customized to show a subtle indicator if desired
 */
export function PageLoadingIndicator() {
  return (
    <div className="w-full h-full min-h-[200px]">
      {/* Intentionally minimal - no spinner, keeps the experience seamless */}
      {/* The previous page remains visible while this loads */}
      {/* Add a subtle indicator here if you want visual feedback */}
    </div>
  );
}
